<template>
  <div id="">
    <v-row no-gutters>
      <v-col>
        <v-progress-linear :active="loadingDate" color="accent" :indeterminate="true" ></v-progress-linear>
      </v-col>
    </v-row>




    <v-alert
      border="left"
      colored-border
      type="warning"
      icon="warning"
      elevation="2"
      v-show="!loadingDate"
      v-if="dataFormated.length == 0"
      class="ma-4">
      Sin datos para mostrar
    </v-alert>

<div class="timeline" v-show="dataFormated.length > 0" :class="{
                                mobile: isMobile,
                                fullscreen: isFullscreen
                              }">

  <div class="corner">
    <div class="corner-title">
      <span class="pa-2">
        Trabajadores
      </span>
    </div >
    <div class="extend-corner">
      <div class="ex-corner-title">
        <span class="pa-2">
          Total
        </span>
      </div>
    </div>
    <div class="extend-bottom-corner">

    </div>
  </div>

  <div class="container-tl">
    <header>
      <div class="header-container"  :style="{ width: (widthContainer) + 'px' }">
        <div class="agno-calendario" v-for="(months, year) in groupedDates" :key="'year-'+year">
          <span class="agno">{{year}}</span>
          <div class="meses">
            <div class="mes-calendario" v-for="(days, month) in months" :key="'month-'+month">
              <span class="mes">{{month}}</span>
              <div class="dias">
                <div class="dia-calendario" v-for="(day, index) in days":key="'day-'+index" :class="{weekend:day.isWeekend}">
                  <span class="d-print-none">
                  {{day.dateMoment.utc().format("dd D")}}
                  </span>
                  <span class="d-none d-print-block">
                  {{day.dateMoment.utc().format("D")}}
                  </span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="header-extend-container">

      </div>
    </header>

    <nav class="left">
      <div class="nav-item-list">
        <div class="nav-item" v-for="(item, index) in dataFormated" :key="'tr-'+index"
              @click="showTrabajadorDialog(item)"
              :class="index%2==0?'primary lighten-5':''">
          <div class="item-title px-2 py-1 blue-grey--text text--darken-3 truncate" v-if="item.trabajador" >
            {{item.trabajador.nombre}}
          </div>
        </div>
      </div>

      <div class="extend-nav-list">
        <div class="ex-nav-item" v-for="(item, index) in dataFormated" :key="'tr-ex-'+index"
              :class="index%2==0?'primary lighten-5':''">
          <div class="num">{{item.total}}</div>
        </div>
      </div>

    </nav>

    <section class="table">

      <div class="list-cube" v-for="(item, index) in dataFormated" :key="'list-cube-'+index"
              :class="index%2==0?'primary lighten-5':''"
              :style="{ width: widthContainer + 'px' }">
        <div class="cube"
        v-for="(as, indexAs) in item.data"
        @click="showTrabajadorDialog(item, as.dateMoment)"
        dep-class="{warn_dep:as.value == 0, full:as.value == 1}">
        <span :class="{'accent darken-3 white--text font-weight-bold':as.isCod}" class="px-2">
        {{as.value == 0 ? '-' : as.value}}
        </span>
      </div>
      </div>

    </section>

  </div>




    <nav class="right">

    </nav>

    <list-tarja-dialog  v-model="showedTrabajadorDialog"
                        :fullscreen="isMobile"
                        :trabajador="trabajadorDialog"
                        :dates="datesDialog"
                        @change="getData()"

                        >
    </list-tarja-dialog>

<!--
                        :contratos="contratos"
                        :centrosCosto="centrosCosto"
                        :labores="sublabores"
                        :trabajadores="trabajadores"
-->

</div>





















  </div>
</template>
<script>
import _ from "lodash";
import moment from "moment";
import Repository from "@/models/repoIrricrops";
import listTarjaDialog from "@/components/listTarjaDialog";

export default {
  name  : "Asistencia",
  props: {
    trabajadores: {},
    dates: {
      //dateInicio  : moment().startOf('month'),
      //dateFin     : moment().endOf('month'),
      //dateMonth   : moment().startOf('month').format("YY-MM"),
    },
    variable:{}
  },
  components: {
    listTarjaDialog,
  },
  data  : () => ({
    data                   : [], //datos de peticion /asistencias
    dataFormated           : [],
    //dateInicio             : moment().startOf('month'),
    //dateFin                : moment().endOf('month'),
    //dateMonth              : moment().startOf('month').format("YY-MM"),
    loadingDate            : false,
    showedTrabajadorDialog : false,
    trabajadorDialog       : null,
    datesDialog            : {},

    //delete
    asistenciaModel : {
      trabajador    : {
        nombre : "Persona "
      },
      asistencias:[]
    },

    //dates           : [],
    datesTable      : [],
    groupedDates    : [],
    asistencias     : [],
    //dayHover        : null,
    trabajadorHover : null

  }),
  computed:{
    isMobile(){
      return this.$store.getters.isMobile;
    },
    empresaSelected(){
      return this.$store.getters.empresaSelected;
    },
    widthContainer(){
      if(!this.dataFormated || this.dataFormated.length == 0) return "";
      return this.dataFormated[0].data.length * (this.isMobile ? 50 : 80); // $day_width
    },
    isFullscreen(){
        return true;
    }
  },
  created() {
    //this.variable = _.first(this.optionsVariable);
    this.getData();
  },
  watch:{
    variable(){
      this.getData();
    },
    dates(){
      this.getData();
    },
    trabajadores(){
          //this.getData();
    },
    empresaSelected(){
          this.getData();
    },
  },
  methods: {
    getTrabajadorById(id){
      if(this.trabajadores == null) return null;
      return _.find(this.trabajadores, {id:id});
    },

    /*
    selectMonth(){
      this.dateInicio = moment(this.dateMonth+"-01", "YY-MM-DD");
      this.dateFin = moment(this.dateMonth+"-01", "YY-MM-DD").endOf("month");;
      this.dateMenuMonth = false;
      this.getData();
    },
    */

    formatPrice(value) {
      let val = (value/1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

    /*
    moveMonth(cant){
      this.dateInicio = this.dateInicio.add(cant, "month");
      this.dateFin    = this.dateFin.add(cant, "month");
      this.dateMonth  = moment(this.dateMonth+"-01", "YY-MM-DD").add(cant, "month").format("YY-MM");
      this.getData();
    },
    */

    showTrabajadorDialog(item, date){
      this.trabajadorDialog = item.trabajador;
      if(date){
        this.datesDialog = {date:date.format("YYYY-MM-DD")};
      }else{
        this.datesDialog = {
          dateInicio : this.dates.dateInicio.format("YYYY-MM-DD"),
          dateFin    : this.dates.dateFin.format("YYYY-MM-DD")
        }
      }
      this.showedTrabajadorDialog = true;
    },







    hideTrabajadorDialog(){
      this.showedTrabajadorDialog = false;
    },






    getData(){
      if(this.empresaSelected == null) return null;
      if(this.dates == null) return null;

      var self = this;

      this.loadingDate = true;

      var params = {
          fecha_inicio : _.cloneDeep(this.dates.dateInicio).format("YYYY-MM-DD"),
          fecha_fin    : _.cloneDeep(this.dates.dateFin).format("YYYY-MM-DD"),
          empresa_id   : this.empresaSelected.id,
        }

      if(this.variable){
        params.variable = this.variable.var;
      }


      return Repository.get('asistencias',{params : params })
      .then(res => {
        this.data         = res.data.data;
        this.datesTable        = _.map(this.data[0].slice(1, this.data[0].length), data => moment.unix(data));


        this.groupedDates = _(this.datesTable).groupBy(date => date.utc().year())
                              .mapValues(dates => _(dates).groupBy(date => date.utc().format("MMM"))
                                                          .mapValues(dates =>{
                                                            return _.map(dates, date => {
                                                              return {
                                                                dateMoment: date,
                                                                isWeekend: [6, 7].indexOf(date.utc().isoWeekday()) > -1
                                                              };
                                                            })
                                                          }).value()
                            ).value();




        this.dataFormated = _.map(this.data.slice(1, this.data.length), (data, index) => {


          var dataTrabajadorFormated = data.slice(1, data.length).map((d, index) => {
            if(self.variable && self.variable.formated == "currency" && d[1] == null){
              var dformated = self.formatPrice(d[0]);
              return {
                value: (dformated == 0 ? 0 : "$ "+_.round(dformated, 2) ),
                dateMoment: this.datesTable[index]
              }
            }
            return {
              value: _.round(d[1] ? d[1]: d[0], 2),
              isCod : d[1] !== null,
              dateMoment: this.datesTable[index]
            }
          });


          //_.sum(data.slice(1, data.length));
          var total =  _.sumBy(data.slice(1, data.length), d => d[0]);
          total = _.round(total, 2);


          var trabajador = this.getTrabajadorById(data[0]);

            return Object.freeze({
              trabajador_id : data[0],
              trabajador    : trabajador,
              total         : (self.variable && self.variable.formated == "currency") ? "$ "+self.formatPrice(total) : total,
              totalNum      : total,
              data          : dataTrabajadorFormated
            });


        });
        this.dataFormated = _.filter(this.dataFormated, d => d.totalNum);



        this.loadingDate = false;

      });
    }





  }
}
</script>
<style lang="scss" scoped>

  $header_height:     57px;
  $header_day_width:  15px;
  $header_day_height: 19px;
  $ex_header_height:  0px;
  $nav_width:         300px;
  $ex_nav_width:      70px;
  $nav_right_width:   0px;
  $day_height:        30px;
  $day_width:         80px;
  //$test_width:        2700px;
  $test_height:       auto;


  $nav_width_mobile:         150px;
  $ex_nav_width_mobile:      50px;
  $day_width_mobile:         50px;

  $weekend_color:   rgb(66,165,245, 0.1);
  $hover_color:     rgb(0, 0, 0, 0.1);
  $hover_color_day: rgba(0, 0, 0, 0.2);
  $warn_color:      #ef9a9a;             //red 100
  $full_color:      #c8e6c9;             // green 100

  //--------------------------------------

  .timeline {
    //border: 1px solid blue;
    position: relative;
    font-family: "Roboto", sans-serif;
    height: calc(100vh - 83px) !important; // << 83px hack

    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      opacity: 0.5;
    }

    ::-webkit-scrollbar-corner {
      background: #cfd8dc;
    }

    ::-webkit-scrollbar-track {
      background: #cfd8dc;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background: rgb(41,121,255);//blue a700
    }

    .corner {
      position: absolute;
      left: 0px;
      top: 0px;
      z-index: 4;
      background: white;
      color: #607d8b; // blue grey 500
      width: $nav_width + $ex_nav_width;
      height: $header_height + $ex_header_height;
      border-bottom: 1px solid #b0bec5; // blue grey 200
      box-sizing: border-box;
      .corner-title {
        height: inherit;
        display: inline-block;
        text-align:left;
        box-sizing: border-box;
        font-size: 12px;
        vertical-align: top;
        position: relative;
        span{
          position: absolute;
          left: 0px;
          bottom: 0px;
          width: 100%;
        }
      }
      .extend-corner {
        position: absolute;
        left: $nav_width;
        width: $ex_nav_width;
        top: 0px;
        height: $header_height + $ex_header_height;
        background: white;
        overflow: hidden;
        border-bottom: 1px solid #b0bec5; // blue grey 200
        box-sizing: border-box;
        .ex-corner-title {
          height: inherit;
          //width: 50px; //temp
          width: inherit;
          display: inline-block;
          margin-right: -1px;
          text-align: right;
          box-sizing: border-box;
          font-size: 12px;
          vertical-align: top;
          position: relative;
          span {
            position: absolute;
            left: 0px;
            bottom: 0px;
            width: 100%;
            padding-right: 14px !important;
          }
        }
      }
      .extend-bottom-corner {
        height: $ex_header_height;
        left: 0px;
        top: $header-height;
        position: absolute;
        background: red;
      }
    }

    nav.right {
      background: #eceff1; //blue grey 50
      position: absolute;
      right: 0px;
      top: 0px;
      width: $nav_right_width;
      height: $test_height;
      z-index: 5;
    }

    .container-tl {
      //background: red;
      width: calc(100% - #{$nav_right_width});
      height: 300px;
      position: relative;
      overflow: scroll;
      margin: 0px;
      //background: grey;

      header {
        height: $header_height + $ex_header_height;
        //width: $test_width + $nav-width + $ex_nav_width;
        width: fit-content;
        position: sticky;
        top: 0px;
        background: white;
        z-index: 3;
        border-bottom: 1px solid #b0bec5; // blue grey 200
        box-sizing: border-box;
        color: #455a64;
        padding-top: 8px;
        .header-container {
          position: relative;
          margin-left: $nav_width + $ex_nav_width;
          position: inline-block;
        }
        .agno-calendario {
          display: inline-block;
          font-size: 10px;
          .agno {
            position: sticky;
            left: $nav_width + $ex_nav_width + 5px;
            display: inline-block;
          }
          .meses {
            display: block;
          }
          .mes-calendario {
            display: inline-block;
            .mes {
              display: inline-block;
              position: sticky;
              left: $nav_width + $ex_nav_width + 5px;
            }
            .dias {
              .dia-calendario {
                width: $day_width;
                height: $header_day_height;
                display: inline-block;
                vertical-align: top;
                font-size: 12px;
                margin-right: -1px; //temp
                border-left: 1px solid #cfd8dc; //blue grey 100
                box-sizing: border-box;
                padding-left: 6px;
                &.hover{
                  background: $hover_color;
                }
                &.weekend{
                  background: $weekend_color;
                }
              }
            }
          }
        }
        .header-extend-container {
          height: $ex-header-height;
          color: pink;
          left: 0px;
          top: $header-height;
          position: absolute;
        }
      }

      nav.left {
        background: #78909c; //blue grey 400
        position: sticky;
        left: 0px;
        width: $nav_width + $ex_nav_width;
        height: $test_height;
        z-index: 2;
        border-right: 1px solid #b0bec5 !important; // blue grey 200
        overflow: hidden;
        .nav-item-list {
          .nav-item {
            width: $nav_width;
            height: $day_height;
            box-sizing: border-box;
            background: white;
            border-bottom: 1px solid #b0bec5 !important; // blue grey 200
            cursor: pointer;
            .item-title {
              //padding: 5px 3px;
              width:inherit;
              font-size: 14px;
              display: inline-block;
              &:hover{
                background: $hover_color !important;
              }
              .subtitle {
                display: block;
                font-size: 12px;
              }
            }
            .light {
              width: 20px;
              height: $day-height;
              display: inline-block;
              vertical-align: top;
              position: relative;
              &:after {
                position: absolute;
                left: calc(50% - 5px);
                top: calc(50% - 5px);
                display: block;
                content: "";
                width: 10px;
                height: 10px;
                border-radius: 50%;
              }
              &.red:after {
                background: #f44336; //red 500
              }
            }
          }
        }

        .extend-nav-list {
          background: white;
          position: absolute;
          left: $nav_width;
          top: 0px;
          width: $ex_nav_width;
          overflow: hidden;
          .ex-nav-item {
            height: $day_height;
            border-bottom: 1px solid #b0bec5 !important; // blue grey 200
            box-sizing: border-box;
            width: inherit;
            &.hover{
              background: $hover_color;
            }
            .num {
              //width: 50px; //temp
              width:inherit;
              display: inline-block;
              //margin-right: -1px;
              padding-right: 14px;
              height: $day_height;
              line-height: $day_height;
              font-size: 12px;
              text-align:right;
              span {
                font-size: 10px;
                color: #546e7a;
              }
            }
          }
        }
      }

      .table {
        position: absolute;
        left: $nav_width + $ex_nav_width;
        top: $header_height + $ex_header_height;
        background: white;

        .list-cube {
          //width: $test_width;
          display: block;
          height: $day_height;
          box-sizing: border-box;
          &:hover{
            background: $hover_color !important;
          }
          .cube {
            width: $day_width;
            height: $day_height;
            line-height: $day_height;
            border-left: 1px solid #cfd8dc; // blue grey 100
            border-top: 1px solid #cfd8dc;
            box-sizing: border-box;
            display: inline-block;
            margin-right: -1px;
            margin-top: -1px;
            position: relative;
            text-align: center;
            font-size: 12px;
            vertical-align: top;
            cursor: pointer;
            &:hover{
              background: $hover_color_day !important;
            }
            &.full{
              background: $full_color;
            }
            &.warn{
              background: $warn_color;
            }
          }
        }
      }
    }

    &.fullscreen{
      .container-tl{
        height: inherit;
      }
    }

    &.mobile{
      height: calc(100vh - 200px) !important; // << 83px hack
      .corner{
        width: $nav_width_mobile + $ex_nav_width_mobile;
        .extend-corner{
          left: $nav_width_mobile;
          width: $ex_nav_width_mobile;
        }
      }
      .container-tl{
        header{
          .header-container{
            margin-left: $nav_width_mobile + $ex_nav_width_mobile;
          }
          .agno-calendario{
            .agno{
              left: $nav_width_mobile + $ex_nav_width_mobile + 5px;
            }
          }
          .mes-calendario{
            .mes{
              left: $nav_width_mobile + $ex_nav_width_mobile + 5px;
            }
            .dias{
              .dia-calendario{
                width: $day_width_mobile;
              }
            }
          }
        }
        nav.left{
          width: $nav_width_mobile + $ex_nav_width_mobile;
          .nav-item-list{
            .nav-item{
              width: $nav_width_mobile;
            }
          }
          .extend-nav-list{
            width:$ex_nav_width_mobile;
            left: $nav_width_mobile;
          }
        }
      }
      .table{
        left: $nav_width_mobile + $ex_nav_width_mobile;
        .list-cube{
          .cube{
            width: $day_width_mobile;
          }
        }
      }
    }
  }

  @media print{

    $nav_width:    200px;
    $ex_nav_width: 50px;
    $day_width:    25px;

    .timeline{
      .corner{
        width: $nav_width + $ex_nav_width;
      }
      .extend-corner {
        left: $nav-width !important;
        width: $ex_nav_width !important;
      }



      nav.right {
        width: $nav_right_width;
      }
      nav.left{
        width: $nav_width + $ex_nav_width !important;
        font-size: 12px !important;
        .nav-item-list {
          .nav-item {
            width: $nav_width !important;
            max-width: $nav_width !important;
          }
        }

        .extend-nav-list {
          width: $ex_nav_width !important;
          left: $nav_width !important;
        }

      }

      .table {
        left: $nav_width + $ex_nav_width !important;
        .list-cube{
          width: auto !important;
          .cube {
            max-width: $day_width;
            text-align: center;
            span{
              padding: 0px 2px !important;
              white-space: nowrap;
            }
          }
        }
      }

      .container-tl {
        width: calc(100% - #{$nav_right_width});
        height: auto;
        header{
          .header-container{
            margin-left: $nav_width + $ex_nav_width;
            width: auto !important;
          }
          .agno, .mes{
            left: $nav_width + $ex_nav_width + 5px !important;
          }
          .dias{
            .dia-calendario{
              width: $day_width;
              max-width: $day_width;
              padding: 0px !important;
              background-color: transparent !important;
              text-align: center;
            }
          }
        }
      }



    }
  }

  </style>
